import { Entity } from "generated/openApi";

// try to use { ...defaultDataModel, ...otherFields } or initDataModel function instead .. 
// this function loses typechecking because param: any .. propertyName is not checked
export const createEntity = <T extends Entity>(param: any): T => {
  return {
    ...param,
    deleted: false,
    hardDeleted: false,
    id: 0,
  };
};
